export default {
  PNP_1: {
    title: 'Total de Publicaciones Owned y Earned',
    description: 'Suma de publicaciones propias y no propias recopiladas en la investigación.',
  },
  PNP_2: {
    title: 'Alcance de Sentimiento por Etiqueta Owned + Earned',
    description: 'Suma del alcance y distribución de publicaciones propias y no propias por Etiquetas registradas en la investigación y su desglose por polaridad.',
  },
  PNP_3: {
    title: 'Sentimiento por Término Owned + Earned',
    description: 'Suma de la distribución de publicaciones propias y no propias por los términos más mencionados y su desglose por polaridad.',
  },
  PNP_4: {
    title: 'Sentimiento por Tema Owned + Earned',
    description: 'Suma de la distribución de publicaciones propias y no propias por los Temas registrados en la investigación más mencionados y su desglose por polaridad.',
  },
  PNP_5: {
    title: 'Salud de Marca Owned + Earned',
    description: 'Representa, como gauge, el resultado de la ecuación: (publicaciones propias y no propias positivas / total de publicaciones propias y no propias recopiladas * 100) - (publicaciones propias y no propias negativas / total de publicaciones propias y no propias recopiladas * 100).',
  },
  PNP_6: {
    title: 'Distribución por Canal Owned + Earned',
    description: 'División de las publicaciones por canal de recopilación propias y no propias.',
  },
  PNP_7: {
    title: 'Total de Usuarios para Owned y Earned',
    description: 'Recuento de usuarios únicos que generaron el total de publicaciones propias y no propias en la investigación.',
  },
  PNP_8: {
    title: 'Alcance Potencial para Owned y Earned',
    description: 'Representa el 20% de la suma de seguidores/suscriptores de los perfiles recopilados para publicaciones propias y no propias.',
  },
  PNP_9: {
    title: 'Publicaciones por Etiqueta para Owned y Earned',
    description: 'Distribución de publicaciones por etiquetas asignadas para Owned y Earned.',
  },
  PNP_10: {
    title: 'Total de Publicaciones Únicas Owned y Earned',
    description: 'Suma de publicaciones únicas propias y no propias recopiladas en la investigación.',
  },
  PNP_11: {
    title: 'Sentimiento en el Tiempo para Publicaciones e Interacciones',
    description: 'Distribución de la suma de publicaciones e interacciones recibidas por su polaridad a lo largo de un período de tiempo.',
  },
  PNP_12: {
    title: 'Publicaciones por Etiqueta en el Tiempo',
    description: 'Distribución de la suma de publicaciones propias y no propias por Etiquetas asignadas en la investigación a lo largo del tiempo.',
  },
  PNP_13: {
    title: 'Publicaciones en el Tiempo',
    description: 'Distribución lineal de la suma de publicaciones e interacciones de Listening + Métricas Propias recopiladas a lo largo de un período de tiempo.',
  },
  PNP_14: {
    title: 'Distribución por Sentimiento',
    description: 'Suma de publicaciones e interacciones (Listening + Métricas Propias) divididas por polaridad positiva, negativa o neutra.',
  },
  PNP_15: {
    title: 'Proyección de Muestreo de Publicaciones',
    description: 'Proyección de publicaciones muestreadas para Listening + Métricas Propias.',
  },
  PNP_16: {
    title: 'Total de Publicaciones, Compartidos y Comentarios',
    description: 'Suma de publicaciones propias y no propias, compartidos y comentarios.',
  },
  PNP_17: {
    title: 'Total de Publicaciones, Compartidos y Comentarios en el Tiempo',
    description: 'Distribución de la suma de publicaciones propias y no propias, compartidos y comentarios a lo largo del tiempo.',
  },
};
